import { render, staticRenderFns } from "./DecisionImport.vue?vue&type=template&id=6fb12985&scoped=true&"
import script from "./DecisionImport.vue?vue&type=script&lang=ts&"
export * from "./DecisionImport.vue?vue&type=script&lang=ts&"
import style0 from "./DecisionImport.vue?vue&type=style&index=0&id=6fb12985&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb12985",
  null
  
)

export default component.exports